export default __webpack_public_path__ + "static/media/rescueoriginalgif.64e9d925.gif";